import React from 'react';
import DisplayComments from "./components/DisplayComments";
import DraftContentReader from "../../components/editor/DraftContentReader";

class ModerationPopup extends React.Component {
    constructor(props) {
        super(props);
        this.limit = 10;
        this.state = {
            alertDecline: false,
            limit: this.limit,
            skip: 0,
            currentPage: 1
        };
        this.handleAlertDecline = this.handleAlertDecline.bind(this);
        this.handleStatusAll = this.handleStatusAll.bind(this);
    }

    handleAlertDecline() {
        this.setState({alertDecline: !this.state.alertDecline});
    }

    handleStatusAll() {
        this.props.handleStatusAll(this.props.type, this.props.currentSelection._id, 'deleted');
        this.handleAlertDecline();
    }


    render() {
        return (
            <div className="moderate-popup">
                <div className="container">
                    <div className="title">{this.props.currentSelection.title}</div>
                    <div className="img-container">
                        {this.props.parentKind === 'medias' && this.props.currentSelection.fileName && (
                            <img src={this.props.currentSelection.previewUrl}
                                 alt={this.props.currentSelection.title}/>)}
                        {(this.props.parentKind === "status") &&
                        <span className="article"><DraftContentReader contentRaw={this.props.currentSelection.contentRaw} /></span>}
                    </div>
                    {/*<div className="row justify-center my-8">*/}
                    {/*    <Button disabled={false}*/}
                    {/*            size={"small"}*/}
                    {/*            btnStyle={"primary-reverse"}*/}
                    {/*            onClick={() => console.log("accept all")}*/}
                    {/*            content={"Valider tous les commentaires"}/>*/}
                    {/*    <Button disabled={false}*/}
                    {/*            size={"small"}*/}
                    {/*            btnStyle={"cancel-reverse"}*/}
                    {/*            onClick={() => console.log("decline all")}*/}
                    {/*            content={"Supprimer tous les commentaires"}/>*/}
                    {/*    <Modal toggle={this.state.alertDecline} handleClose={() => this.handleAlertDecline()}>*/}
                    {/*        <Alert text="Voulez vous vraiment supprimer tous les commenaires ?"*/}
                    {/*               handleClose={() => this.handleAlertDecline()}*/}
                    {/*               handleDelete={() => this.handleStatusAll()}/>*/}
                    {/*    </Modal>*/}
                    {/*</div>*/}
                    <div className="comments-to-moderate column">
                        <DisplayComments parentKind={this.props.parentKind}
                                         ownerId={this.props.currentSelection.owner._id}
                                         parentId={this.props.currentSelection._id}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default ModerationPopup;
